<template>
	<div class="main-header">
		<div class="title-wrap">
			<router-link to="/">
				<h1>
					<img alt="mamezou recruiting site" src="../../assets/common/title.svg" width="234" />
				</h1>
			</router-link>
		</div>
		<div class="hamburger-button-wrap" v-on:click="openHandler" v-bind:class="openObj">
			<div class="hamburger-button">
				<i />
				<i />
				<i />
			</div>
		</div>
		<div class="global-nav-set" v-on:click="closeHandler" v-bind:class="openObj">
			<div class="global-nav-back"></div>
			<div class="global-nav-wrap">
				<div class="global-nav-inner">
					<nav class="global-nav">
						<div class="nav-title">
							MENU
						</div>
						<p>
							<router-link to="/">
								<span>トップページ</span>
							</router-link>
						</p>
						<p class="genre-title">
							<!-- <router-link to="/business_and_technology">
								<span>事業・プロジェクト紹介</span>
							</router-link> -->
							<span>事業・プロジェクト紹介</span>
						</p>
						<p>
							<router-link to="/business_platform">
								<span>ビジネスプラットフォーム領域</span>
							</router-link>
						</p>
						<p>
							<router-link to="/embedded">
								<span>エンベデッド領域</span>
							</router-link>
						</p>
						<p>
							<router-link to="/robot">
								<span>ロボット領域</span>
							</router-link>
						</p>
						<p>
							<router-link to="/dxai_solution">
								<span>DX・AIソリューション領域</span>
							</router-link>
						</p>
						<p class="genre-title is-normal">
							<router-link to="/growth">
								<span>技術者としての成長</span>
							</router-link>
						</p>
						<p class="genre-title">
							<span>事業部インタビュー</span>
						</p>
						<p>
							<router-link to="/people_tadahiro" class="group">
								<span>ビジネスプラットフォーム領域</span>
							</router-link>
						</p>
						<p>
							<router-link to="/people_satoshi" class="group">
								<span>DX・AIソリューション領域</span>
							</router-link>
						</p>
						<p>
							<router-link to="/people_seiji" class="group">
								<span>ロボット領域</span>
							</router-link>
						</p>
						<!-- <p class="genre-title">
							<span>クロストーク</span>
						</p>
						<p>
							<router-link to="/discussion_young" class="group">
								<span>AI・データサイエンス領域 × 若手社員</span>
							</router-link>
						</p>
						<p>
							<router-link to="/discussion_mgr" class="group">
								<span>エンタープライズ、組込み領域 × マネージャー</span>
							</router-link>
						</p> -->
						<p class="entry">
							<a href="https://hrmos.co/pages/mamezou-recruit" target="_blank">
								<span>募集職種・エントリー</span>
							</a>
						</p>
						<p>
							<router-link to="/referral">
								<span>社員紹介特設ページ</span>
							</router-link>
						</p>
						<p>
							<a href="https://www.mamezou.com/" target="_blank">
								<span>豆蔵コーポレートサイト</span>
							</a>
						</p>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Header',
	data() {
		return {
			openObj: {
				open: false,
			},
		};
	},
	methods: {
		openHandler: function() {
			this.openObj.open = !this.openObj.open;
		},
		closeHandler: function() {
			this.openObj.open = false;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main-header {
	z-index: 2;
	position: relative;
	@media print, screen and (max-width: 1160px) {
		margin-bottom: 1px;
	}
}
.title-wrap {
	display: inline-block;
	background-color: #543193;
	margin: 0;
	max-width: 480px;
	width: 100%;
	@media print, screen and (min-width: 1161px) {
		top: 30px;
		position: absolute;
	}
	@media print, screen and (max-width: 1160px) {
		max-width: calc(100% - 48px);
		height: 47px;
	}
	a {
		display: block;
	}
	h1 {
		text-align: center;
		margin: 0;
		position: relative;
		@media print, screen and (min-width: 1161px) {
			margin-left: -20px;
		}
		img {
			top: -3px;
			position: relative;
		}
		&:after {
			@media print, screen and (min-width: 1161px) {
				content: '';
				width: 50px;
				height: 2px;
				display: block;
				background-color: #fff;
				top: calc(50% - 2px);
				position: absolute;
				right: 0;
			}
		}
	}
}
.hamburger-button-wrap {
	cursor: pointer;
	background-color: #543193;
	width: 82px;
	height: 82px;
	right: 20px;
	top: 20px;
	z-index: 900;
	position: fixed;
	cursor: pointer;
	transition: 0.2s;
	&:hover {
		opacity: 0.7;
	}
	@media print, screen and (min-width: 1161px) {
		border-radius: 100%;
	}
	@media print, screen and (max-width: 1160px) {
		width: 47px;
		height: 47px;
		top: 0px;
		right: 0px;
	}
	&.open {
		.hamburger-button {
			i {
				&:nth-child(1) {
					transform: rotate(45deg) scale(0.8, 0.05);
				}
				&:nth-child(2) {
					transform: rotate(-45deg) scale(0.8, 0.05);
				}
				&:nth-child(3) {
					transform: rotate(45deg) scale(0.8, 0.05);
				}
			}
		}
	}
}
.hamburger-button {
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 30px;
	height: 40px;
	position: absolute;
	display: inline-block;
	vertical-align: bottom;
	transition-duration: 0.2s;
	transition-animation-timing: ease-out;
	i {
		position: absolute;
		display: block;
		width: 100%;
		height: 100%;
		background: #fff;
		transition: all 200ms;
		&:nth-child(1) {
			transform: scale(0.8, 0.05);
		}
		&:nth-child(2) {
			transform: scale(0.8, 0.05) translate(0, -550%);
		}
		&:nth-child(3) {
			transform: scale(0.8, 0.05) translate(0, 550%);
		}
	}
}
.global-nav-set {
	position: fixed;
	height: 100%;
	width: 100%;
	// position: fixed;
	right: -100%;
	top: 0;
	z-index: 1;
	transition-duration: 0.2s;
	transition-animation-timing: ease-out;
	&.open {
		right: 0;
	}
}
.global-nav-back {
	width: 100%;
	height: 100%;
}
.global-nav-wrap {
	color: #fff;
	width: 100%;
	height: 100%;
	background-color: rgba(84, 49, 147, 0.9);
	top: 0;
	max-width: 500px;
	padding-top: 60px;
	right: 0;
	position: absolute;
}
.global-nav-inner {
	margin: 0 auto;
	max-width: 90%;
	height: 100%;
}
.global-nav {
	display: block;
	overflow-y: scroll;
	padding-bottom: 100px;
	height: 100%;
	box-sizing: border-box;

	scrollbar-width: none; /*Firefox対応のスクロールバー非表示コード*/
	-ms-overflow-style: none; /*Internet Explore対応のスクロールバー非表示コード*/
	&::-webkit-scrollbar {
		display: none; /*Google Chrome、Safari、Microsoft Edge対応のスクロールバー非表示コード*/
	}
	.nav-title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 1.5em;
	}
	a {
		line-height: 3em;
		span {
			border-bottom: 1px solid #fff;
		}
	}
	p {
		margin: 0;
	}
	.genre-title {
		font-size: 16px;
		font-weight: bold;
		margin-top: 2em;
		margin-bottom: 3px;
		&.is-normal {
			font-weight: normal;
		}
	}
	.group {
		line-height: 2em;
	}
	.entry {
		margin-top: 2em;
		color: #ffb082;
		span {
			border-bottom: 1px solid #ffb082;
		}
	}
}
</style>
